import React, { useState, useEffect } from "react";
import "../components/App.css";
import axios from "axios";
import dayjs from "dayjs";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { API_BASE_URL } from "../config/config";
import { useActiveCareUser } from "../hooks/useActiveCareUser";

const ClaimHistory = () => {
  const [claims, setClaims] = useState([]);
  const [displayType, setDisplayType] = useState("claimHistory");
  const { userDetails } = useActiveCareUser();

  useEffect(() => {
    const fetchUserClaims = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/myclaims`, {
          email: userDetails.email,
        });
        setClaims(response.data);
      } catch (error) {
        console.error("Error fetching user claims:", error);
      }
    };

    if (userDetails?.email) {
      fetchUserClaims();
    }
  }, [userDetails]);

  return (
    <Container>
      <div className="claim-container">
          <FormControl style={{ marginBottom: "2rem" }}>
            <Select
              value={displayType}
              onChange={(e) => setDisplayType(e.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="claimHistory">Claim History</MenuItem>
              <MenuItem value="claimStatus">Claim Status</MenuItem>
            </Select>
          </FormControl>
          {displayType === "claimHistory" ? (
            <div className="claim-history-container">
              <Typography variant="h5" textAlign="center">
                Claim History
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Date of Claim Requested</b>
                      </TableCell>
                      <TableCell>
                        <b>Date of Claim Amount Paid</b>
                      </TableCell>
                      <TableCell>
                        <b>Mode of Payment</b>
                      </TableCell>
                      <TableCell>
                        <b>Claim Amount</b>
                      </TableCell>
                      <TableCell>
                        <b>Transaction ID of Claim Transfer</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {claims.map((claim, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {dayjs(claim.created_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>
                          {dayjs(claim.updated_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>Bank Transfer</TableCell>
                        <TableCell>{claim.amount}</TableCell>
                        <TableCell>{claim.claim_id}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <div className="claim-status-container">
              <Typography variant="h5" textAlign="center">
                Claim Status
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Date of Claim Requested</b>
                      </TableCell>
                      <TableCell>
                        <b>Status of Claim</b>
                      </TableCell>
                      <TableCell>
                        <b>Claim Type</b>
                      </TableCell>
                      <TableCell>
                        <b>Claim Value Passed</b>
                      </TableCell>
                      <TableCell>
                        <b>Check Message [if Any]</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {claims.map((claim, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {dayjs(claim.date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>{claim.status}</TableCell>
                        <TableCell>{claim.claim_type}</TableCell>
                        <TableCell>{claim.admin_amount}</TableCell>
                        <TableCell>{claim.admin_message}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
    </Container>
  );
};

export default ClaimHistory;
